import dayjs from 'dayjs';

export const isOlderThanOneHour = (time: string) =>
  dayjs().diff(dayjs(time), 'hour') > 1;
